import script from "./customerDiscountCardList.vue?vue&type=script&setup=true&lang=js"
export * from "./customerDiscountCardList.vue?vue&type=script&setup=true&lang=js"

import "./customerDiscountCardList.vue?vue&type=style&index=0&id=17012211&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17012211"]])

export default __exports__